import { useNavigate, useParams } from 'react-router-dom';
import Button from '@/components/base/Button';
import Loading from '@/components/base/Loading';
import ErrorState from '@/components/base/ErrorState';
import EmptyState from '@/components/base/EmptyState';
import ProjectForm from '@/pages/projects/components/ProjectForm';
import { useProject } from '@/hooks/useProjects';

export default function EditProjectPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { project, loading, error, reload } = useProject(id);

  if (loading) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50">
        <Loading label="Cargando proyecto..." />
      </div>
    );
  }

  if (error) {
    return <ErrorState message={error} onRetry={reload} />;
  }

  if (!project) {
    return (
      <EmptyState
        icon="ri-folder-warning-line"
        title="Proyecto no encontrado"
        description="El proyecto solicitado no existe o fue eliminado."
        action={
          <Button icon="ri-arrow-left-line" onClick={() => navigate('/proyectos')}>
            Volver a proyectos
          </Button>
        }
      />
    );
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Button variant="ghost" icon="ri-arrow-left-line" onClick={() => navigate(`/proyectos/${project.id}`)}>
          Volver al detalle
        </Button>
        <p className="text-sm text-foreground-500">
          Editando: <strong className="text-foreground-800">{project.name}</strong>
        </p>
      </div>

      <ProjectForm
        mode="edit"
        initial={project}
        onSaved={(saved) => navigate(`/proyectos/${saved.id}`)}
        onCancel={() => navigate(`/proyectos/${project.id}`)}
      />
    </div>
  );
}